import { HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const PUBLIC_CATALOG_PATH_PATTERNS: RegExp[] = [
  /^vendors\/[^/]+$/,
  /^rooms\/\d+$/,
  /^rooms\/available$/,
  /^event-types$/,
  /^amenities$/,
  /^layouts$/,
];

const AUTHENTICATED_VENDOR_PATHS = [
  'vendors/payrexx-verification-status',
  'vendors/translations',
];

export function isPublicCatalogRequest(request: HttpRequest<unknown>): boolean {
  const apiPath = apiPathOf(request.url);

  return (
    request.method === 'GET' &&
    apiPath !== null &&
    !AUTHENTICATED_VENDOR_PATHS.includes(apiPath) &&
    PUBLIC_CATALOG_PATH_PATTERNS.some((pattern) => pattern.test(apiPath))
  );
}

function apiPathOf(url: string): string | null {
  const apiRootUrl = environment.apiUrl + '/';

  return url.startsWith(apiRootUrl) ? url.slice(apiRootUrl.length) : null;
}
